define.alias("ember-math-helpers/helpers/sum", "settings/helpers/sum");